import { Component } from '@angular/core';
import { DialogService } from "primeng/dynamicdialog";
import { TCModalComponent } from './components/t-c-modal/t-c-modal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  template: `
    <div class="footer-container">
      <div class="footer-links">
        <a (click)="openModal('Privacy Policy')">Privacy Policy</a>
        <span>|</span>
        <a (click)="openModal('Terms & Conditions')">Terms & Conditions</a>
      </div>
      <div class="footer-copy">ATS Mako, LLC All Right Reserved</div>
    </div>
  `,
  styles: [
    `
      .footer-container {
        text-align: center;
        padding: 1rem;
        font-size: 14px;
        color: #555;
        width: 100%;
        background-color: #fff;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      }

      .footer-links {
        margin-bottom: 0.5rem;
      }

      .footer-links a {
        margin: 0 0.5rem;
        color: #007ad9;
        text-decoration: none;
      }

      .footer-links a:hover {
        text-decoration: underline;
      }

      .footer-links span {
        margin: 0 0.3rem;
        color: #999;
      }

      .footer-copy {
        font-weight: 500;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule],
})
export class FooterComponent {

  constructor(public dialog: DialogService) { }


  openModal(type: string) {
    const screenWidth = window.innerWidth;
    let dialogWidth = '800px';
    if (screenWidth <= 576) dialogWidth = '95vw';
    else if (screenWidth <= 768) dialogWidth = '85vw';

    const ref = this.dialog.open(TCModalComponent, {
      header: type,
      width: dialogWidth,
      closable: true,
      closeOnEscape: true,
      data: type
    });
  }

}
